export default __webpack_public_path__ + "static/marketplace-blog-resource-img-fd7c4deb60bd71402044f5432b201901.png";